import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ImageTextSlider from "../../components/pager";
import arrowBack from "../../assets/Images/arrow_back_ios_new.png";
import flash from "../../assets/Images/flash_white.png";
import like from "../../assets/Images/like.png";
import building from "../../assets/Images/apap.png";
import refresh from "../../assets/Images/refresh.png";
import question from "../../assets/Images/question.png";
import contract from "../../assets/Images/contract.png";
import forward_arrow from "../../assets/Images/forward_arrow.png";
import { useAsaSession, useIsLoading, useAsaSessionPagesMutation } from '../../services/AsaSessionServices'
import { useActiveSubscriptions, useSubscriptionsPlans } from '../../services/AsaApiServices'
import { IAsaSession, SessionPage, Plan } from "../../types/types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";

import LoaderComponent from "../../components/LoaderComponent";
import { showCustomToast } from "../../services/toastService";
import {
  AnalyticsService,
  AnalyticsAction,
  AnalyticsFeature,
} from "../../services/AnalyticsService";

const GoalSubscription = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useIsLoading();
  const { data: session } = useAsaSession();
  const { data: subscriptions } = useActiveSubscriptions();
  const { data: subscriptionsPlans } = useSubscriptionsPlans();
  const sessionMutation = useAsaSessionPagesMutation();
  const [showPlans, setShowPlans] = useState(false);

  // Handling Update Session response

  useEffect(() => {
    if (session) {
      setIsLoading(false);

      AnalyticsService.track(
        "One Goal Subscription",
        AnalyticsAction.View,
        AnalyticsFeature.OneGoal,
      );
    }
  }, [session]);

  const handlePlanClick = async (plan: Plan) => {
    AnalyticsService.track("One Goal Plan Clicked", AnalyticsAction.Click, AnalyticsFeature.OneGoal, {
      subscriptionName: plan?.subscriptionTitle,
      price: plan?.recurringAmount,
      billingCycle: plan?.billingCycle,
    });
    const isSubscriptionMatched = subscriptions?.some(
      (x) => x.subscriptionPlanCode === plan?.subscriptionPlanCode
    );

    if (isSubscriptionMatched) {
      navigate("/manageSubscriptions");
    } else {
      try {
        const sessionToUpdate: IAsaSession = { ...session } as IAsaSession;
        sessionToUpdate.sessionPages = undefined;
        const sessionpages = [] as SessionPage[];
        const selectPackagePage: SessionPage = {
          pageNumber: 2,
          pageName: "GOALS PLANS",
          pageTitle: "Select Package",
          pageDescription: "Select Package",
          pageUrl: "/onegoal",
          pageStatusMessage: "INCOMPLETE",
          pageData: JSON.stringify(plan),
        } as SessionPage;
        sessionpages.push(selectPackagePage);

        sessionpages.push({
          pageNumber: 81,
          pageName: "Landingyes",
          pageTitle: "Landingyes",
          pageDescription: "Landingyes",
          pageUrl: "/onegoal",
          pageData: JSON.stringify({ Landing: "true" }),
        } as SessionPage);

        const response = await sessionMutation.mutateAsync({
          asaSession: sessionToUpdate,
          extraPages: sessionpages,
        });
        AnalyticsService.track("One Goal Proceed Success", AnalyticsAction.API_Result, AnalyticsFeature.OneGoal, {
          subscriptionName: plan?.subscriptionTitle,
          price: plan?.recurringAmount,
        });
        navigate("/subscriptionpayment");
      } catch (error) {
        AnalyticsService.track("One Goal Proceed Error", AnalyticsAction.API_Result, AnalyticsFeature.OneGoal, {
          subscriptionName: plan?.subscriptionTitle,
          price: plan?.recurringAmount,
        });
        console.error("Error updating session:", error);
        showCustomToast(t("errorProcessingCheckout"), true);
      }
    }
  }
  const handleBackClick = () => {

    const targetPage = session?.sessionPages?.find((page) => page.pageNumber === 0);
    if (targetPage) {
      const pageData = JSON.parse(targetPage.pageData);
      const backActionDynamicLink = pageData.backActionDynamicLink;
      if (backActionDynamicLink) {
        window.location.href = backActionDynamicLink;
      } else {
        console.error(t("backActionNotFound"));
      }
    }

  };

  const slides = [
    {
      image: building,
      text: t("seeAllAccounts"),
    },
    {
      image: refresh,
      text: t("accountBalancesSync"),
    },
    {
      image: contract,
      text: t("transactionsSentAutomatically"),
    },
    {
      image: like,
      text: t("dragDropCategorize"),
    },
    {
      image: question,
      text: t("prioritySupport"),
    },
  ];

  const clickSubscription = () => {
    AnalyticsService.track("One Goal Continue Clicked", AnalyticsAction.Click, AnalyticsFeature.OneGoal);
    setIsLoading(true);

    //  console.log("Updated Local data ::: " + UpdatedLocalData);
    setTimeout(() => {
      setIsLoading(false);
      setShowPlans(true);
    }, 2000); // 5000 milliseconds = 5 seconds


  };

  return (
    <div className="bg-gray-900 flex justify-center items-center min-h-screen">
      {isLoading && <LoaderComponent />}
      <div className="bg-gradient-to-r from-[#1B9C83] to-[#20BD9D] w-full h-screen overflow-y-auto text-white relative z-20">
        <div className="flex items-center justify-evenly space-x-8 pt-8 p-3">
          <div className="rounded-[10px] p-1 w-[70px] h-[45px] styled-box-goal flex items-center justify-center">
            <img
              className="cursor-pointer w-[20px] h-[20px]"
              src={arrowBack}
              onClick={handleBackClick}
              alt={t("back")}
            />
          </div>

          <h1 className="font-poppins ml-3 text-[22px] leading-[28px] tracking-[1px] w-[500px] h-[56px] mt-6">
            {t("loveMoneySync")}
          </h1>
        </div>

        <img
          src={flash}
          className="relative top-2 left-5 z-50 w-[65px] h-[65px]"
          alt="Flash"
        />

        <div className=" bg-[#EBECF0] dark:bg-[#121212] dark:text-white text-[#4E4E4E] top-8 rounded-more  mx-auto rounded-t-[3rem] absolute bottom-0 left-0 right-0 h-full overflow-y-auto mt-24">
          <div className="h-full p-6 shadow-lg">
            <div className="flex items-center mb-2">
              <img
                src={flash}
                className="relative -top-2 hidden left-5 z-50 w-[80px] h-[80px]"
                alt="Flash"
              />
              <span className="font-semibold relative -top-4 font-poppins left-20 text-[18px] ">
                One Goal
              </span>
            </div>

            <div className="border-[3.91px] border-[#1B9C83] rounded-xl">
              <div className="rounded-xl bg-[#c9eae5] p">
                <button className="bg-[#39a68f] border-[#1B9C83] button-one-goal border text-black relative top-2 left-3 px-2 py-1 tracking-widest rounded-full border-b-4 text-xs mb-6">
                  {t("subscribe")}
                </button>

                <ImageTextSlider slides={slides} />
              </div>
              <div className="bg-white">
                <div className="space-y-3 mt-6 p-2 bg-white rounded-xl">
                  {!showPlans ? (
                    <button
                      onClick={clickSubscription}
                      className="w-full bg-[#39a68f] subscription-goal text-white py-5 rounded-lg shadow-md font-poppins font-semibold flex justify-between items-center"
                    >
                      <span className="ml-4 font-poppins">{t("continue")}</span>
                      <img
                        src={forward_arrow}
                        alt="Forward Arrow"
                        className="w-2 h-4 mr-4"
                      />
                    </button>
                  ) : (
                    <>
                      {subscriptionsPlans && subscriptionsPlans.length > 0 ? (
                        subscriptionsPlans.map((plan) => (
                          <button
                            key={plan.subscriptionPlanCode}
                            onClick={() => handlePlanClick(plan)}
                            className={`w-full text-white p-4 rounded-xl text-left flex justify-between items-center ${
                              subscriptions?.some(
                                (x) => x.subscriptionPlanCode === plan.subscriptionPlanCode
                              )
                                ? "bg-gradient-to-r from-[#5BCCB3] to-[#3aa690]"
                                : "bg-gradient-to-r from-[#1B9C83] to-[#3aa690]"
                            }`}
                          >
                            <div>
                              <div className="font-poppins text-style-one-goal">
                                {plan.billingCycle === "Monthly"
                                  ? `$${plan.recurringAmount} / ${t("month")}`
                                  : `$${plan.recurringAmount} / ${t("year")}`}
                              </div>
                              { !subscriptions?.some((x)=>x.subscriptionPlanCode===plan.subscriptionPlanCode) &&
                                <div className="font-medium font-poppins small-text-one-goal">
                                  {t("billedCycle", {
                                    cycle:
                                      plan.billingCycle.toLowerCase() === "annually"
                                        ? t("year")
                                        : t("month"),
                                  })}
                                </div>
                              }
                              { subscriptions?.some((x)=>x.subscriptionPlanCode===plan.subscriptionPlanCode) &&
                                <div className="font-medium font-poppins small-text-one-goal">
                                  {t("managePlan")}
                                </div>
                              }
                            </div>
                            <div className="w-2 h-2">
                              <img src={forward_arrow} alt="Forward Arrow" />
                            </div>
                          </button>
                        ))
                      ) : (
                        <p className="no-plans-message font-poppins">
                          {t("noSubscriptionPlansAvailable")}
                        </p>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-6 px-6">
              <p className="continiuep text-left font dark:text-white text-black text-[13px] font-medium paragraph-one-goal"
                dangerouslySetInnerHTML={{
                  __html: t("acceptTermsPrivacy", {
                    termsOfService: `<a href="https://onegoalfinance.com/terms" target="_blank" class="underline font-poppins font-semibold text-[13px]">${t(
                      "termsOfService"
                    )}</a>`,
                    privacyPolicy: `<a href="https://onegoalfinance.com/privacy-policy" target="_blank" class="underline font-poppins font-semibold text-[13px]">${t(
                      "privacyPolicy"
                    )}</a>`,
                  }),
                }}
              >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoalSubscription;
